import {DateFormat} from "../../../../helpers/DateFormat";
import {MenuItem, TextField} from "@material-ui/core";
import React from "react";

const DEFAULT_SELECTOR_VALUE = "all"

function reduce(dates){
    if (!dates){
        return []
    }
    return Object.values(dates.reduce((accum, item) => {
        const date = new DateFormat(item)
        accum[date.date()] = date
        return accum
    }, {})).sort((a, b) => {
        let diff = b.raw.getFullYear() - a.raw.getFullYear()
        if (diff !== 0) {
            return diff
        }
        diff = b.raw.getMonth() - a.raw.getMonth()
        if (diff !== 0){
            return diff
        }
        return b.raw.getDate() - a.raw.getDate()
    }).map(date => date.date())
}

function SonaSafeTextField(props){
    return <TextField variant="outlined" size='small' fullWidth {...props}/>
}

function SonaSafeSelectorField(props){
    return (
        <SonaSafeTextField label={props.label} value={props.value} onChange={props.onChange} select>
            <MenuItem key={DEFAULT_SELECTOR_VALUE} value={DEFAULT_SELECTOR_VALUE}>All</MenuItem>
            {props.children}
        </SonaSafeTextField>
    )
}

function SonaSafeDateSelectorField({dates, value, onChange}){
    return (
        <SonaSafeSelectorField label="Date" value={value} onChange={onChange}>
            {reduce(dates).map(date => {
                return (
                    <MenuItem key={date} value={date}>{date}</MenuItem>
                )
            })}
        </SonaSafeSelectorField>
    )
}

function getFilterClause(column, value){
    if (value === DEFAULT_SELECTOR_VALUE){
        return null
    }
    return (row) => row[column] === value
}

function getDateFilterClause(column, value){
    if (value === DEFAULT_SELECTOR_VALUE){
        return null
    }
    value = new DateFormat(value)
    return (row) => (new DateFormat(row[column])).isSameDay(value)
}

function filter(filters, rows){
    if (rows === null || rows === undefined){
        return []
    }
    filters = filters.filter(filter => filter)
    switch (filters.length){
        case 0:
            return rows
        case 1:
            return rows.filter(filters[0])
        default:
            return rows.filter((row) => {
                for (let i = 0, j = filters[0]; j; j = filters[++i]){
                    if (!j(row)){
                        return false
                    }
                }
                return true
            })
    }
}

export {DEFAULT_SELECTOR_VALUE, SonaSafeTextField, SonaSafeSelectorField, SonaSafeDateSelectorField, getFilterClause, getDateFilterClause, filter}